/**
 * Response of GET /v2/WorkOrders/:workOrderId/LastDriverLocation.
 */
export interface DriverGpsLocation {
  latitude: number;
  longitude: number;
  /**
   * A FormattedTimestamp object, not an ISO string or a bare epoch: the API sends
   * `{ timeStamp, formattedDate, formattedTime, standardizedDate, standardizedTime, timeZone }`.
   * Left as `unknown` rather than typed out because nothing in the portal reads it yet — narrow it
   * at the point of use.
   */
  reportTime?: unknown;
}

/**
 * The endpoint reports an unavailable position as a zero coordinate rather than omitting it — driver
 * tracking disabled for the customer, or the driver out of range under EN_ROUTE accessibility — so
 * plotting it unchecked would drop a marker in the Gulf of Guinea and blow the map viewport out to
 * the whole planet. Nullable because "no driver on this route" is a routine state, not an error.
 */
export const hasPosition = (location: DriverGpsLocation | null | undefined): location is DriverGpsLocation =>
  !!(location?.latitude && location?.longitude);
